export const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,15}))$/
export const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
export const assetLengthRegex = /^.{10,18}$/;
export const tagRegex = /^[ A-Za-z0-9_@./#&+-]*$/;
export const descDisclaimerRegex = /^[A-Za-z0-9 _$'.!%,@&-]{1,150}$/;
export const urlRegex = new RegExp(/^(https:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[\w\-./]*)?$/);
// export const urlRegex = new RegExp("^http(s)?://[\\w.-]+(?:\\.[\\w\\.-]+)+[\\w\\-\\._~:/?%#[\\]@!\\$&'\\(\\)\\*\\+,;=.]{0,120}$")
export const debiSharingGrpRegex = /^[A-Za-z0-9\-\\/! ]*$/;
export const min4Max6LengthRegex = /^\d{4,6}$/;
// Android package/application IDs allow letters of either case (each segment must start with a
// letter, followed by letters/digits/underscores) — was lowercase-only, rejecting valid
// uppercase-containing package IDs like "com.MyCompany.MyApp" (IP-9726).
export const androidPackageId = /^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)*$/;
export const deviceLabelLength = /^.{2,50}$/;
export const storeDBALength = /^.{2,50}$/;
export const tpnLabelLength = /^.{2,25}$/;
export const ghppTagRegex = /^[A-Za-z0-9]{1}[ A-Za-z0-9]{0,15}$/;
export const spaceAllowedRegex = /^(?!\s)[a-zA-Z0-9](?:[a-zA-Z0-9 \-_'])*$/;
export const strictCardNumberRegex = new RegExp(
  "^(?:4[0-9]{15}|" +  // Visa (16 digits only)
  "5[1-5][0-9]{14}|" +  // MasterCard (16 digits)
  "222[1-9][0-9]{12}|22[3-9][0-9]{13}|2[3-6][0-9]{14}|27[01][0-9]{13}|2720[0-9]{12}|" + // MasterCard (New Range, 16 digits)
  "6(?:011|5[0-9]{2}|4[4-9][0-9])[0-9]{12}|" +  // Discover (16 digits)
  "3[47][0-9]{13}|" +  // American Express (15 digits)
  "3(?:0[0-5]|[68][0-9])[0-9]{11}|" +  // Diners Club (14 digits)
  "(?:2131|1800|35[0-9]{3})[0-9]{11}|" +
  "(62[0-9]{14,17})|(81[0-9]{14,17})|" +  // China UnionPay (16 to 19 digits)
  "[*]{16})$");  // JCB (16 digits)
export const cvvRegex = /^[0-9]{3,4}$|[***]/
export const zipCodeRegex = /^[0-9]{5}$/;
export const streetRegex = /^[a-zA-Z0-9.,\-#/'&—\s]+$/;
